import React, { useState } from 'react';
import * as S from './DSOHeader.styles';
import Image from 'next/image';
import useComponentVisible from 'utils/hooks/useComponentVisible';
import { useAuth0UserInfo } from 'reactQuery/queries/useAuth0UserInfo';
import { useRouter } from 'next/router';
import { useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { DsoCart } from 'types/dso/DsoCart.types';
import {
  IoCartOutline,
  IoPersonOutline,
  IoSettingsOutline,
} from 'react-icons/io5';
import {
  useBootstrapDsoCart,
  useRetrieveDsoShippingAddresses,
  useRetriveDsoAllTaxonDetails,
} from 'reactQuery/queries';
import { LoadingSpinner } from 'styles/sharedStyles';

const DSOHeader = () => {
  const [isHoveringLogout, setIsHoveringLogout] = useState(false);
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  const { data } = useAuth0UserInfo();
  const router = useRouter();

  useRetrieveDsoShippingAddresses();
  useRetriveDsoAllTaxonDetails();
  const { data: dsoCart, isLoading: isDsoCartLoading } = useBootstrapDsoCart();

  const cartItemCount = dsoCart?.lineItems?.length ?? 0;
  const userName = data?.given_name + ' ' + data?.family_name;

  const handleLogout = () => {
    setIsComponentVisible(false);
    window.location.href = '/dso/logout';
  };

  return (
    <S.HeaderWrapper>
      <S.Container>
        <S.BrandSection>
          <Image
            src="/images/invisalignLogo.svg"
            alt="Invisalign"
            height={32}
            width={150}
          />
          <S.Divider />
          <S.PortalText>Align Special Markets Portal</S.PortalText>
        </S.BrandSection>

        <S.HeaderActions>
          <S.IconCircle onClick={() => router.push('/dso/cartview?showcart=1')}>
            {
              <S.CartBadge>
                {isDsoCartLoading ? <LoadingSpinner /> : cartItemCount}
              </S.CartBadge>
            }
            <IoCartOutline />
          </S.IconCircle>

          <S.IconCircle onClick={() => router.push('/dso/ids_store_settings')}>
            <IoSettingsOutline />
          </S.IconCircle>

          <S.ProfileSection ref={ref}>
            <S.ProfileButton
              onClick={() => setIsComponentVisible(!isComponentVisible)}
            >
              <S.ProfileIconCircle>
                <IoPersonOutline />
              </S.ProfileIconCircle>
              <S.UserNameWrapper>
                <S.UserName>{userName}</S.UserName>
                <S.DropdownIcon
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  isOpen={isComponentVisible}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </S.DropdownIcon>
              </S.UserNameWrapper>
            </S.ProfileButton>

            {isComponentVisible && (
              <S.MenuItemsWrapper>
                <S.MenuItemsContainer>
                  <S.MenuItemLink
                    href="#"
                    active={isHoveringLogout}
                    onMouseEnter={() => setIsHoveringLogout(true)}
                    onMouseLeave={() => setIsHoveringLogout(false)}
                    onClick={e => {
                      e.preventDefault();
                      handleLogout();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                      />
                    </svg>
                    Logout
                  </S.MenuItemLink>
                </S.MenuItemsContainer>
              </S.MenuItemsWrapper>
            )}
          </S.ProfileSection>
        </S.HeaderActions>
      </S.Container>
    </S.HeaderWrapper>
  );
};

export default DSOHeader;
